import { Clock } from 'lucide-react';

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

interface DataFreshnessProps {
  lastUpdated?: string;
}

function getStalenessColor(lastUpdated: string): string {
  const hoursAgo = (Date.now() - new Date(lastUpdated).getTime()) / (1000 * 60 * 60);
  if (hoursAgo > 72) return 'text-destructive';
  if (hoursAgo > 48) return 'text-yellow-600';
  return 'text-muted-foreground';
}

export function DataFreshness({ lastUpdated }: DataFreshnessProps) {
  const date = lastUpdated ?? new Date().toISOString();
  const formatted = new Date(date).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className={cn('hidden items-center gap-1 text-xs sm:flex', getStalenessColor(date))}>
            <Clock className="h-3 w-3" />
            <span>Data as of {formatted}</span>
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>Analytics data is refreshed nightly via batch processing.</p>
          <p className="text-xs text-muted-foreground">Last update: {formatted}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
